'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitPasswordReset = exports.getUiPasswordReset = exports.PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var PASSWORD_RESET_FAIL = exports.PASSWORD_RESET_FAIL = 'la/ui/passwordReset/FAIL';
var PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_REQUEST = 'la/ui/passwordReset/REQUEST';
var PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_SUCCESS = 'la/ui/passwordReset/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case PASSWORD_RESET_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case PASSWORD_RESET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case PASSWORD_RESET_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.passwordReset;
};

var getUiPasswordReset = exports.getUiPasswordReset = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitPasswordReset = exports.submitPasswordReset = function submitPasswordReset(_ref) {
    var bidderId = _ref.bidderId,
        hash = _ref.hash,
        newPassword = _ref.newPassword;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: bidderId,
                                type: PASSWORD_RESET_REQUEST
                            });
                            _context.next = 6;
                            return _api.Auth.postResetPassword({ bidderId: bidderId, deployment: deployment, hash: hash, newPassword: newPassword });

                        case 6:
                            _context.next = 8;
                            return _context.sent;

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: PASSWORD_RESET_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { bidderId: bidderId },
                                payload: _context.t0,
                                type: PASSWORD_RESET_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/passwordReset.js
// module id = fWpZ
// module chunks = 57